import type { Shared } from '@studio/types';
import { isAIEnriching } from '../isAIEnriching';
import { isProcessing } from '../isProcessing';
import { isSaveOnlyUpgradable } from '../isSaveOnlyUpgradable';

const getPollingMedia = (items: Shared.Library.BaseMediaItem[], vodPlanId?: string | null): string[] => {
  const media: string[] = [];
  items.forEach((item) => {
    if (isProcessing(item) || isAIEnriching(item) || isSaveOnlyUpgradable(item, vodPlanId)) {
      media.push(item.mediaId);
    }
  });
  return media;
};

export default getPollingMedia;
